module.exports = __webpack_public_path__ + "img/cross_red.1f62dbad.svg";